<template>
  <div class="row">
    <card
      type="tasks"
      class="col-sm"
      style="height: auto; padding-bottom: 30px;overflow-x: auto;"
    >
      <template slot="header">
        <div style="">
          <div class="row">
            <div class="">
              <h4 class="title d-inline">用户管理</h4>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px">
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <base-input>
                <el-input
                  @blur="onBlur"
                  type="search"
                  class="mb-3 search-input"
                  prefix-icon="el-icon-search"
                  placeholder="搜索账号或邮箱"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedData">
              <el-table-column label="id" prop="id" :min-width="80">
              </el-table-column>
              <el-table-column label="用户名" prop="username" :min-width="120">
              </el-table-column>
              <el-table-column label="密码" prop="password" :min-width="120">
              </el-table-column>
              <el-table-column label="邮箱" prop="email" :min-width="120">
              </el-table-column>
              <el-table-column
                label="注册时间"
                prop="add_time"
                :min-width="120"
                :formatter="timeFormatter"
              >
              </el-table-column>
              <el-table-column
                label="最后登录时间"
                prop="last_time"
                :min-width="120"
                :formatter="timeFormatter"
              >
              </el-table-column>

              <el-table-column label="查看套餐" prop="state" :min-width="100" align="center">
                <template slot-scope="{ row }">
                  <base-button
                    size="sm"
                    style="font-size: 0.685rem"
                    class="animation-on-hover"
                    type="danger"
                    @click="hangleQuery(row.id)"
                    >查看</base-button
                  >
                </template>
              </el-table-column>

              <el-table-column label="状态" prop="state" :min-width="80" align="center">
                <template slot-scope="{ row }">
                  <!-- <base-button
                    v-if="row.state === 0"
                    style="margin-left: 6px"
                    size="sm"
                    round
                    icon
                    type="danger"
                    @click="changeUserState(row.id)"
                    ><i class="tim-icons icon-button-pause"></i
                  ></base-button> -->
                  <!-- <base-button
                    v-if="row.state === 1"
                    style="margin-left: 6px"
                    size="sm"
                    round
                    icon
                    type="success"
                    @click="changeUserState(row.id)"
                    ><i class="tim-icons icon-triangle-right-17"></i
                  ></base-button> -->
                  <badge v-if="row.state === 0" type="danger">封禁</badge>
                  <badge v-if="row.state === 1" type="success">正常</badge>
                  <badge v-if="row.state === 2" type="warning">限制</badge>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                显示 {{ from + 1 }} 到 {{ to }} 总数 {{ total }} 条
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </div>
      </template>
    </card>

    <div>
      <modal :show.sync="modals1" headerClasses="justify-content-center">
        <card
          type="tasks"
          class="col-sm"
          style="height: auto; padding-bottom: 20px;overflow-x: auto;"
          slot="header"
        >
          <h4 class="title title-up" style="text-align: center">套餐信息</h4>
          <div style="margin-top: 30px">
            <base-table :data="packageTableData" :columns="packageColumns">
              <template slot="columns">
                <th>id</th>
                <th>套餐名称</th>
                <th>网站名称</th>
                <th>套餐类型</th>
                <th>剩余次数</th>
                <th>开始时间</th>
                <th>结束时间</th>
                <th>是否到期</th>
              </template>
              <template slot-scope="{ row }">
                <td>{{ row.id }}</td>
                <td>{{ row.package_name }}</td>
                <td>{{ row.site_name }}</td>
                <td>
                  <badge type="default" v-if="row.package_type == 1"
                    >时间套餐</badge
                  >
                  <badge type="default" v-if="row.package_type == 2"
                    >次数套餐</badge
                  >
                  <badge type="default" v-if="row.package_type == 3"
                    >积分套餐</badge
                  >
                </td>
                <td>{{ row.download_num }}</td>
                <td>{{ changeDateFormat(row.start_time) }}</td>
                <td>{{ changeDateFormat(row.end_time) }}</td>
                <td>
                    <badge v-if="checkTime(row.end_time,row.package_type,row.download_num)==false" type="success">未到期</badge>
                    <badge v-if="checkTime(row.end_time,row.package_type,row.download_num)==true" type="danger">已到期</badge>
                    
                </td>
              </template>
            </base-table>
          </div>
        </card>
        <card
          type="tasks"
          class="col-sm"
          style="height: auto; padding-bottom: 30px;overflow-x: auto;"
        >
          <h4 class="title title-up" style="text-align: center">激活码信息</h4>
          <div style="margin-top: 30px">
            <base-table :data="cdkTableData" :columns="cdkColumns">
              <template slot="columns">
                <th>id</th>
                <th>激活码</th>
                <th>套餐名称</th>
                <th>套餐类型</th>
                <th>使用时间</th>
                <th>生成时间</th>
                <th>使用状态</th>
                <th>生成者</th>
              </template>
              <template slot-scope="{ row }">
                <td>{{ row.id }}</td>
                <td>{{ row.cdk }}</td>
                <td>{{ row.package_name }}</td>
                <td>
                  <badge type="default" v-if="row.package_type == 1"
                    >时间套餐</badge
                  >
                  <badge type="default" v-if="row.package_type == 2"
                    >次数套餐</badge
                  >
                  <badge type="default" v-if="row.package_type == 3"
                    >积分套餐</badge
                  >
                </td>
                <td>{{ changeDateFormat(row.use_time) }}</td>
                <td>{{ changeDateFormat(row.add_time) }}</td>
                <td>
                  <badge type="danger" v-if="row.state == 1">已使用</badge>
                  <badge type="success" v-if="row.state == 0">未使用</badge>
                </td>
                <td>{{ row.admin_username }}</td>
              </template>
            </base-table>
          </div>
        </card>

        <card
          type="tasks"
          class="col-sm"
          style="height: auto; padding-bottom: 30px;overflow-x: auto;"
        >
          <h4 class="title title-up" style="text-align: center">
            在线支付信息
          </h4>
          <div style="margin-top: 30px">
            <base-table :data="payTableData" :columns="payColumns">
              <template slot="columns">
                <th>id</th>
                <th>套餐名称</th>
                <th>网站订单号</th>
                <th>易支付订单号</th>
                <th>支付ip</th>
                <th>创建时间</th>
                <th>付款时间</th>
                <th>支付方式</th>
                <th>支付状态</th>
              </template>
              <template slot-scope="{ row }">
                <td>{{ row.id }}</td>
                <td>{{ row.package_name }}</td>
                <td>{{ row.order_no }}</td>
                <td>{{ row.trade_no }}</td>
                <td>{{ row.pay_ip }}</td>
                <td>{{ changeDateFormat(row.create_time) }}</td>
                <td>{{ changeDateFormat(row.pay_time) }}</td>
                <td>
                  <badge type="info" v-if="row.pay_type == 0">支付宝</badge>
                  <badge type="warning" v-if="row.pay_type == 1">微 信</badge>
                </td>
                <td>
                  <badge type="success" v-if="row.pay_state == 1">已支付</badge>
                  <badge type="danger" v-if="row.pay_state == 0">未支付</badge>
                </td>
                <!-- 
                <td>
                  <badge type="danger" v-if="row.state == 1">已使用</badge>
                  <badge type="success" v-if="row.state == 0">未使用</badge>
                </td>
                <td>{{ row.admin_username }}</td> -->
              </template>
            </base-table>
          </div>
        </card>
        <div
          style="
            display: flex;
            justify-content: space-between;
            margin-top: 30px;
          "
        >
          <base-button
            type="secondary"
            @click="modals1 = false"
            style="margin-right: auto"
            >取消</base-button
          >
          <base-button
            type="primary"
            style="margin-left: auto"
            @click="modals1 = false"
            >确认</base-button
          >
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "../../components";
import Swal from "sweetalert2";
import { http } from "../../util/http.js";
import { changeDateFormat, checkTime } from "../../util/utils.js";
import Badge from "@/components/Badge";
import Modal from "@/components/Modal";
import BaseTable from "@/components/BaseTable";

export default {
  components: {
    BaseTable,
    Modal,
    Badge,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    queriedData() {
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.pagination.total;
    },
  },
  data() {
    return {
      checkTime,
      changeDateFormat,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      blurredSearchQuery: "",
      propsToSearch: ["cdk", "email", "age"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      modals1: false,
      packageTableData: [],
      packageColumns: [
        "id",
        "package_name",
        "site_name",
        "package_type",
        "download_num",
        "start_time",
        "end_time",
      ],
      cdkTableData: [],
      cdkColumns: [
        "id",
        "cdk",
        "package_name",
        "package_type",
        "use_time",
        "add_time",
        "state",
        "admin_username",
      ],
      payTableData: [],
      payColumns: [
        "id",
        "package_name",
        "order_no",
        "trade_no",
        "pay_ip",
        "create_time",
        "pay_time",
        "pay_type",
        "pay_state",
      ],
    };
  },
  methods: {
    hangleQuery(id) {
      console.log(id);
      
      http
        .post(
          "/v1/agent/deputyGetUserPackageInfo",
          {
            userId: id,
          },
          { headers: { agentToken: localStorage.getItem("agentToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
          this.packageTableData = res.data.data.packageInfo;
          this.cdkTableData = res.data.data.cdkInfo;
          this.payTableData = res.data.data.payInfo;
          this.modals1 = true;
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    onBlur() {
      // 当输入框失去焦点时，改变 blurredSearchQuery 的值
      this.blurredSearchQuery = this.searchQuery;
    },
    handleCurrentChange() {      
      http
        .post(
          "/v1/agent/deputyGetAllUser",
          {
            currentPage: this.pagination.currentPage,
            perPage: this.pagination.perPage,
            searchQuery: this.searchQuery,
          },
          { headers: { agentToken: localStorage.getItem("agentToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.pagination.total = res.data.data.total;
          this.tableData = res.data.data.tableData;
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    timeFormatter(row, column, cellValue) {
      // 在这里处理你的数据
      // row 是整个行数据
      // column 是列数据
      // cellValue 是单元格的值
      // 例如你想将名字转为大写形式：
      if (cellValue == "0001-01-01T00:00:00Z") {
        return "";
      } else {
        cellValue = changeDateFormat(cellValue);
        return cellValue;
      }
    },
  },
  mounted() {
    this.handleCurrentChange();
  },
  watch: {
    blurredSearchQuery(newVal, oldVal) {
      // 监控搜索
      if (newVal == "") {
        this.handleCurrentChange();
        return;
      }
      this.handleCurrentChange();
    },
    "pagination.currentPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
    "pagination.perPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
  },
};
</script>
<style scoped lang="scss" >
.pagination-select,
.search-input {
  width: 200px;
}
::v-deep .modal-dialog {
  max-width: 1500px !important;
}
</style>
